import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, withModifiers as _withModifiers, createTextVNode as _createTextVNode, vModelText as _vModelText, withDirectives as _withDirectives, vModelDynamic as _vModelDynamic } from "vue"

const _hoisted_1 = { class: "min-h-screen relative overflow-hidden" }
const _hoisted_2 = { class: "relative z-10 min-h-screen flex items-center justify-center p-4 sm:p-6 lg:p-8" }
const _hoisted_3 = { class: "w-full max-w-3xl" }
const _hoisted_4 = { class: "text-center mb-8" }
const _hoisted_5 = ["src", "alt"]
const _hoisted_6 = { class: "text-center" }
const _hoisted_7 = { class: "text-xl text-white" }
const _hoisted_8 = {
  key: 0,
  class: "mb-6 rounded-md bg-red-50 p-4"
}
const _hoisted_9 = { class: "flex" }
const _hoisted_10 = { class: "ml-3" }
const _hoisted_11 = { class: "text-sm text-red-700" }
const _hoisted_12 = {
  key: 1,
  class: "mb-6 rounded-md bg-yellow-50 p-4"
}
const _hoisted_13 = { class: "flex" }
const _hoisted_14 = { class: "ml-3" }
const _hoisted_15 = { class: "mt-2 text-sm text-yellow-700" }
const _hoisted_16 = { class: "relative" }
const _hoisted_17 = ["type"]
const _hoisted_18 = {
  key: 0,
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24",
  fill: "currentColor",
  class: "w-6 h-6"
}
const _hoisted_19 = {
  key: 1,
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24",
  fill: "currentColor",
  class: "w-6 h-6"
}
const _hoisted_20 = { class: "text-right" }
const _hoisted_21 = { class: "flex justify-center" }
const _hoisted_22 = ["disabled"]

import { ref, computed, onMounted } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import { getBrandBySlug } from '@/config/brands'
import { useAuthStore } from '@/stores/auth'


export default /*@__PURE__*/_defineComponent({
  __name: 'LoginView',
  setup(__props) {

const route = useRoute()
const router = useRouter()
const authStore = useAuthStore()

const currentBrand = computed(() => {
  const brandSlug = route.params.brandSlug as string
  return getBrandBySlug(brandSlug)
})

const isFalken = computed(() => currentBrand.value?.name?.toLowerCase() === 'falken')

// eslint-disable-next-line @typescript-eslint/no-var-requires
const backgroundImage = require('@/assets/staticbg.png')

const email = ref('')
const password = ref('')
const loading = ref(false)
const error = ref('')
const showPassword = ref(false)

const isEmailVerificationError = computed(() => {
  return error.value.toLowerCase().includes('verify your email')
})

onMounted(() => {
  // Redirect to brand selection if no brand is selected
  if (!currentBrand.value) {
    router.push({ name: 'brand-selection' })
  }
})

const handleLogin = async () => {
  try {
    loading.value = true
    error.value = ''

    // Validate input
    if (!email.value || !password.value) {
      throw new Error('Please enter both email and password')
    }

    // Validate brand is selected
    if (!currentBrand.value) {
      throw new Error('Please select a brand first')
    }

    // Call login API with brand_id
    await authStore.login({
      email: email.value,
      password: password.value,
      brand_id: currentBrand.value.id
    })

    // Redirect handled by auth store

  } catch (err: any) {
    if (err.response?.data?.message) {
      error.value = err.response.data.message
    } else if (err.message) {
      error.value = err.message
    } else {
      error.value = 'Login failed. Please try again.'
    }
  } finally {
    loading.value = false
  }
}

const goToSignUp = () => {
  router.push({
    name: 'signup',
    params: { brandSlug: currentBrand.value?.slug }
  })
}

const goToForgotPassword = () => {
  router.push({
    name: 'forgot-password',
    params: { brandSlug: currentBrand.value?.slug }
  })
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: "absolute inset-0 bg-cover bg-center bg-no-repeat",
      style: _normalizeStyle({ backgroundImage: `url(${_unref(backgroundImage)})` })
    }, null, 4),
    _cache[11] || (_cache[11] = _createElementVNode("div", { class: "absolute inset-0 bg-black bg-opacity-70" }, null, -1)),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", null, [
          _createElementVNode("div", _hoisted_4, [
            (currentBrand.value)
              ? (_openBlock(), _createElementBlock("img", {
                  key: 0,
                  src: currentBrand.value.formLogo,
                  alt: currentBrand.value.name,
                  class: "mx-auto w-120 object-contain"
                }, null, 8, _hoisted_5))
              : _createCommentVNode("", true),
            _createElementVNode("h2", {
              class: "text-5xl font-medium",
              style: _normalizeStyle({ color: currentBrand.value?.color })
            }, _toDisplayString(isFalken.value ? 'Road Hazard Ready' : 'TOTAL CONFIDENCE PLAN'), 5),
            _cache[4] || (_cache[4] = _createElementVNode("p", { class: "mt-6 mb-4 text-2xl text-white" }, " Sign In to Your Account ", -1)),
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("p", _hoisted_7, [
                _cache[3] || (_cache[3] = _createTextVNode(" Don't have an account? ")),
                _createElementVNode("a", {
                  href: "#",
                  onClick: _withModifiers(goToSignUp, ["prevent"]),
                  class: "font-medium hover:underline",
                  style: _normalizeStyle({ color: currentBrand.value?.color })
                }, " Sign Up ", 4)
              ])
            ])
          ]),
          (error.value && !isEmailVerificationError.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                _createElementVNode("div", _hoisted_9, [
                  _cache[5] || (_cache[5] = _createElementVNode("div", { class: "flex-shrink-0" }, [
                    _createElementVNode("svg", {
                      class: "h-5 w-5 text-red-400",
                      xmlns: "http://www.w3.org/2000/svg",
                      viewBox: "0 0 20 20",
                      fill: "currentColor"
                    }, [
                      _createElementVNode("path", {
                        "fill-rule": "evenodd",
                        d: "M10 18a8 8 0 100-16 8 8 0 000 16zM8.707 7.293a1 1 0 00-1.414 1.414L8.586 10l-1.293 1.293a1 1 0 101.414 1.414L10 11.414l1.293 1.293a1 1 0 001.414-1.414L11.414 10l1.293-1.293a1 1 0 00-1.414-1.414L10 8.586 8.707 7.293z",
                        "clip-rule": "evenodd"
                      })
                    ])
                  ], -1)),
                  _createElementVNode("div", _hoisted_10, [
                    _createElementVNode("p", _hoisted_11, _toDisplayString(error.value), 1)
                  ])
                ])
              ]))
            : _createCommentVNode("", true),
          (isEmailVerificationError.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                _createElementVNode("div", _hoisted_13, [
                  _cache[8] || (_cache[8] = _createElementVNode("div", { class: "flex-shrink-0" }, [
                    _createElementVNode("svg", {
                      class: "h-6 w-6 text-yellow-400",
                      xmlns: "http://www.w3.org/2000/svg",
                      viewBox: "0 0 24 24",
                      fill: "currentColor"
                    }, [
                      _createElementVNode("path", {
                        "fill-rule": "evenodd",
                        d: "M9.401 3.003c1.155-2 4.043-2 5.197 0l7.355 12.748c1.154 2-.29 4.5-2.599 4.5H4.645c-2.309 0-3.752-2.5-2.598-4.5L9.4 3.003zM12 8.25a.75.75 0 01.75.75v3.75a.75.75 0 01-1.5 0V9a.75.75 0 01.75-.75zm0 8.25a.75.75 0 100-1.5.75.75 0 000 1.5z",
                        "clip-rule": "evenodd"
                      })
                    ])
                  ], -1)),
                  _createElementVNode("div", _hoisted_14, [
                    _cache[6] || (_cache[6] = _createElementVNode("h3", { class: "text-sm font-medium text-yellow-800" }, "Email Verification Required", -1)),
                    _createElementVNode("p", _hoisted_15, _toDisplayString(error.value), 1),
                    _cache[7] || (_cache[7] = _createElementVNode("p", { class: "mt-1 text-xs text-yellow-600" }, " Didn't receive the email? Contact support for assistance. ", -1))
                  ])
                ])
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("form", {
            onSubmit: _withModifiers(handleLogin, ["prevent"]),
            class: "space-y-6"
          }, [
            _createElementVNode("div", null, [
              _withDirectives(_createElementVNode("input", {
                id: "email",
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((email).value = $event)),
                type: "email",
                placeholder: "Email Address*",
                required: "",
                class: "w-full px-8 py-5 bg-transparent border-2 rounded-lg focus:outline-none placeholder-white placeholder:text-lg brand-input",
                style: _normalizeStyle({
                  borderColor: currentBrand.value?.color,
                  color: 'white',
                  '--focus-color': currentBrand.value?.color
                })
              }, null, 4), [
                [_vModelText, email.value]
              ])
            ]),
            _createElementVNode("div", _hoisted_16, [
              _withDirectives(_createElementVNode("input", {
                id: "password",
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((password).value = $event)),
                type: showPassword.value ? 'text' : 'password',
                placeholder: "Password*",
                required: "",
                class: "w-full px-8 py-5 pr-14 bg-transparent border-2 rounded-lg focus:outline-none placeholder-white placeholder:text-lg brand-input",
                style: _normalizeStyle({
                  borderColor: currentBrand.value?.color,
                  color: 'white',
                  '--focus-color': currentBrand.value?.color
                })
              }, null, 12, _hoisted_17), [
                [_vModelDynamic, password.value]
              ]),
              _createElementVNode("button", {
                type: "button",
                onClick: _cache[2] || (_cache[2] = ($event: any) => (showPassword.value = !showPassword.value)),
                class: "absolute inset-y-0 right-0 pr-4 flex items-center text-white hover:opacity-80 transition-opacity"
              }, [
                (showPassword.value)
                  ? (_openBlock(), _createElementBlock("svg", _hoisted_18, _cache[9] || (_cache[9] = [
                      _createElementVNode("path", { d: "M3.53 2.47a.75.75 0 0 0-1.06 1.06l18 18a.75.75 0 1 0 1.06-1.06l-18-18ZM22.676 12.553a11.249 11.249 0 0 1-2.631 4.31l-3.099-3.099a5.25 5.25 0 0 0-6.71-6.71L7.759 4.577a11.217 11.217 0 0 1 4.242-.827c4.97 0 9.185 3.223 10.675 7.69.12.362.12.752 0 1.113Z" }, null, -1),
                      _createElementVNode("path", { d: "M15.75 12c0 .18-.013.357-.037.53l-4.244-4.243A3.75 3.75 0 0 1 15.75 12ZM12.53 15.713l-4.243-4.244a3.75 3.75 0 0 0 4.244 4.243Z" }, null, -1),
                      _createElementVNode("path", { d: "M6.75 12c0-.619.107-1.213.304-1.764l-3.1-3.1a11.25 11.25 0 0 0-2.63 4.31c-.12.362-.12.752 0 1.114 1.489 4.467 5.704 7.69 10.675 7.69 1.5 0 2.933-.294 4.242-.827l-2.477-2.477A5.25 5.25 0 0 1 6.75 12Z" }, null, -1)
                    ])))
                  : (_openBlock(), _createElementBlock("svg", _hoisted_19, _cache[10] || (_cache[10] = [
                      _createElementVNode("path", { d: "M12 15a3 3 0 1 0 0-6 3 3 0 0 0 0 6Z" }, null, -1),
                      _createElementVNode("path", {
                        "fill-rule": "evenodd",
                        d: "M1.323 11.447C2.811 6.976 7.028 3.75 12.001 3.75c4.97 0 9.185 3.223 10.675 7.69.12.362.12.752 0 1.113-1.487 4.471-5.705 7.697-10.677 7.697-4.97 0-9.186-3.223-10.675-7.69a1.762 1.762 0 0 1 0-1.113ZM17.25 12a5.25 5.25 0 1 1-10.5 0 5.25 5.25 0 0 1 10.5 0Z",
                        "clip-rule": "evenodd"
                      }, null, -1)
                    ])))
              ])
            ]),
            _createElementVNode("div", _hoisted_20, [
              _createElementVNode("a", {
                href: "#",
                onClick: _withModifiers(goToForgotPassword, ["prevent"]),
                class: "text-lg font-medium hover:underline",
                style: _normalizeStyle({ color: currentBrand.value?.color })
              }, " Forgot Password? ", 4)
            ]),
            _createElementVNode("div", _hoisted_21, [
              _createElementVNode("button", {
                type: "submit",
                disabled: loading.value,
                class: "px-16 py-3 font-medium text-xl rounded-full hover:opacity-90 transition-opacity",
                style: _normalizeStyle({
                  backgroundColor: currentBrand.value?.buttonColor,
                  color: currentBrand.value?.buttonTextColor,
                  opacity: loading.value ? 0.7 : 1
                })
              }, _toDisplayString(loading.value ? 'Signing in...' : 'Sign In'), 13, _hoisted_22)
            ])
          ], 32)
        ])
      ])
    ])
  ]))
}
}

})